var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalDetails({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.073,
    height: 27.907,
    viewBox: "0 0 29.073 27.907",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-add-friend-5899386",
    d: "M53.145,64.375a5.638,5.638,0,1,1-3.986,1.651L49.187,66a5.619,5.619,0,0,1,3.958-1.626Zm9.91,22.738a.469.469,0,0,1,0-.938h1.9v-1.9a.469.469,0,1,1,.938,0v1.9h1.9a.469.469,0,0,1,0,.938h-1.9v1.9a.469.469,0,1,1-.938,0v-1.9Zm2.37-6.106a5.636,5.636,0,1,1-4.964,8.312c-.094.006-.185.01-.273.01H46.1a4.1,4.1,0,0,1-2.9-1.207l-.025-.028a4.1,4.1,0,0,1-1.182-2.877,8.507,8.507,0,0,1,8.484-8.484h5.343a8.422,8.422,0,0,1,4.623,1.379,8.578,8.578,0,0,1,2.942,3.277,5.619,5.619,0,0,1,2.043-.382Zm-5.361,7.384A5.643,5.643,0,0,1,62.54,81.8a7.637,7.637,0,0,0-2.614-2.9,7.488,7.488,0,0,0-4.11-1.225H50.473a7.569,7.569,0,0,0-7.546,7.546,3.167,3.167,0,0,0,.909,2.22l.023.022a3.165,3.165,0,0,0,2.241.933H60.064Zm8.684-5.069a4.7,4.7,0,0,0-7.586,5.3l0,0a4.7,4.7,0,1,0,7.583-5.309ZM56.468,66.689a4.7,4.7,0,0,0-6.624-.024l-.022.024a4.7,4.7,0,1,0,6.646,0Z",
    transform: "translate(-41.989 -64.375)",
    fill: "#1d1d1f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalDetails);
export default __webpack_public_path__ + "static/media/personalDetails.a88d11bdc58c78a41a10370abd8aaf5e.svg";
export { ForwardRef as ReactComponent };